//
//
//
//
//
//

import Tag from '@/components/Shared/Tag.vue'
export default {
  components: {
    Tag,
  },
  props: {
    isPending: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    type() {
      return this.isPending ? 'is-danger' : 'is-success'
    },
    customStyleClass() {
      return this.isPending ? 'custom-is-danger' : 'custom-is-success'
    },
    text() {
      return this.isPending ? 'Pendiente' : 'Aceptado'
    },
  },
}
